var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.$ceres.isSSR,
          expression: "!$ceres.isSSR",
        },
      ],
      staticClass: "cookie-bar",
      class: {
        out: !_vm.isVisible,
        "border-top bg-white": _vm.isVisible,
        "fixed-bottom": !_vm.isShopBuilder || false,
      },
    },
    [
      _vm.isVisible
        ? _c("div", { staticClass: "container-max" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isExpanded,
                    expression: "!isExpanded",
                  },
                ],
                staticClass: "cookie-bar-default row py-3",
                class: _vm.classes,
                style: _vm.styles,
              },
              [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "a",
                    {
                      staticClass: "toggle-trigger d-block d-md-inline-block",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          _vm.isExpanded = true
                        },
                      },
                    },
                    [_c("i", { staticClass: "fa fa-chevron-up" })]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "h2 mb-3 text-center" }, [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "LucxCeres::Template.cookieBarUseCookies"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" 🍪\n                "),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "h3 mb-3 text-center" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$translate(
                            "LucxCeres::Template.cookieBarRevertCookies"
                          )
                        ) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$translate(
                            "LucxCeres::Template.cookieBarHintText2"
                          )
                        ) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { domProps: { innerHTML: _vm._s(_vm.text) } }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 my-3 button-wrapper" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-white mb-2 mb-md-0",
                      on: {
                        click: function ($event) {
                          _vm.denyAll()
                          _vm.close()
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("LucxCeres::Template.cookieBarDenyAll")
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-white",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          _vm.isExpanded = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "LucxCeres::Template.cookieBarMoreSettings"
                          )
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function ($event) {
                          _vm.acceptAll()
                          _vm.close()
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Ceres::Template.cookieBarAcceptAll")
                        )
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.isExpanded
              ? _c(
                  "div",
                  {
                    staticClass: "row py-3 cookie-bar-expanded",
                    class: _vm.classes,
                    style: _vm.styles,
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "toggle-trigger d-inline-block mb-3",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            _vm.isExpanded = false
                          },
                        },
                      },
                      [_c("i", { staticClass: "fa fa-chevron-down" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mb-3" },
                      [
                        _c("privacy-settings", {
                          attrs: { "consent-groups": _vm.consentGroups },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 my-3 button-wrapper row" },
                      [
                        _c("div", { staticClass: "col-12 col-md-4 mb-1" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-primary-outline",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  _vm.isExpanded = false
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.cookieBarBack"
                                  )
                                )
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-md-4 mb-1" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary-outline",
                              on: {
                                click: function ($event) {
                                  _vm.storeConsents()
                                  _vm.close()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.cookieBarSave"
                                  )
                                )
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-md-4 mb-1" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-orange",
                              on: {
                                click: function ($event) {
                                  _vm.acceptAll()
                                  _vm.close()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.cookieBarAcceptAll"
                                  )
                                )
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _c("div", { staticClass: "cookie-trigger" }, [
            _c(
              "button",
              {
                staticClass: "btn",
                attrs: {
                  title: _vm.buttonTitle,
                  "aria-label": _vm.buttonTitle,
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    _vm.isCollapsed = false
                  },
                },
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "LucxCeres::Template.cookieBarCookieSettings"
                      )
                    )
                  ),
                ]),
              ]
            ),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }